import React from 'react';
import { AiOutlineTags, AiOutlineCompass } from 'react-icons/ai';
import { GiArcheryTarget } from 'react-icons/gi';
import { BiCheckShield, BiCog } from 'react-icons/bi';
import { LiaToolsSolid } from 'react-icons/lia';

const ICON_MAP = {
	AiOutlineTags: <AiOutlineTags />,
	AiOutlineCompass: <AiOutlineCompass />,
	GiArcheryTarget: <GiArcheryTarget />,
	BiCheckShield: <BiCheckShield />,
	LiaToolsSolid: <LiaToolsSolid />,
	BiCog: <BiCog />
};

export default ICON_MAP;
